export default __webpack_public_path__ + "static/media/github-background.09673108.svg";